export const subjectsTypes = [
  {value: 'Site Feedback or Suggestion(s)', label: 'Site Feedback or Suggestion(s)'},
  {value: 'Advertising and Sponsored Content', label: 'Advertising and Sponsored Content'},
  {value: 'Investor Relations', label: 'Investor Relations'},
  {value: 'Career Opportunities', label: 'Career Opportunities'},
  {value: 'Something else entirely...', label: 'Something else entirely...'},
]
